import { isAnyFilterApplied } from './isAnyFilterApplied'

/**
 * Hide express deal on filter deselect by checking each filter against their defaults
 *
 * @param {Object} airSearchRequestModel - Search request
 * @param {Object} filterDefaults - Default filter state
 * @param {Array} sortOptions = Sorting order
 */

export const hideExpressDeals = ({
  airSearchRequestModel,
  filterDefaults,
  sortOptions,
  fromSlice,
  activeTabId,
  AIR_RECO_SORT_BY_DISPLAY_WEB,
}) => {
  /**
   * Used when airSearch call doesn't come from sort selection
   */
  const prevSortOption = airSearchRequestModel?.slices?.[0]?.sortOptions?.[0]

  /**
   * Return false => Only show Express Deals when user:
   * 1. Is on lowest price sort or recommended sort
   * 2. Switch to lowest price sort or recommended sort
   */
  let sortCondition =
    (sortOptions && sortOptions[1] !== 'LOWEST_PRICE') || (!sortOptions && prevSortOption !== 'LOWEST_PRICE')

  if (AIR_RECO_SORT_BY_DISPLAY_WEB) {
    sortCondition =
      (sortOptions && sortOptions?.[1] !== 'LOWEST_PRICE' && sortOptions?.[1] !== 'RECOMMENDED') ||
      (!sortOptions && prevSortOption !== 'LOWEST_PRICE' && prevSortOption !== 'RECOMMENDED')
  }

  const filterCondition = isAnyFilterApplied({ airSearchRequestModel, filterDefaults, forExdRequest: true })
  return Boolean(filterCondition || sortCondition || fromSlice || activeTabId > 1)
}
